module.exports = __webpack_public_path__ + "static/media/sepaca.e815624e.jpg";